import React from "react";
import renderer from "../renderer";
import forEach from "lodash/forEach";

export default function ReactRenderPlugin(app) {

    let global = window || global;

    global.React = React;

    let components = app.components;
    let namespaces = Object.keys(components);

    if (namespaces.length === 0) {
        return;
    }

    forEach(namespaces, (namespace) => {
        renderer.register(namespace, components[namespace]);
    });

    renderer.render(app.components);

}
